module.exports = "//We're working on migrating some of our components to use a new implementation of menus.\n//If you'd like to use the new menu before our migration is complete, please directly\n//require them like this:\n\nimport MenuItem from 'material-ui/lib/menus/menu-item';\nimport MenuDivider from 'material-ui/lib/menus/menu-divider';\n\n<IconMenu iconButtonElement={iconButtonElement}>\n  <MenuItem primaryText=\"Refresh\" />\n  <MenuItem primaryText=\"Send feedback\" />\n  <MenuItem primaryText=\"Settings\" />\n  <MenuItem primaryText=\"Help\" />\n  <MenuItem primaryText=\"Sign out\" />\n</IconMenu>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/raw-code/icon-menus-code.txt
 ** module id = 818
 ** module chunks = 0
 **/